import { api } from 'redux-store/api';

import {
  IGetSchedulePhasesArgs,
  IGetSchedulePhasesResponse,
  ISchedulePhase,
  ICreateSchedulePhaseBody,
  IUpdateSchedulePhaseBody,
  TUpdateSchedulePhaseBulkResponse,
  TUpdateSchedulePhaseBulkBody,
  IDeleteSchedulePhaseBody,
} from './';

enum Endpoints {
  SCHEDULE_PHASES = 'project-schedule/phases/',
}

export const schedulePhasesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSchedulePhases: build.query<IGetSchedulePhasesResponse, IGetSchedulePhasesArgs>({
      query: ({ projectId }) => ({
        url: `${Endpoints.SCHEDULE_PHASES}${projectId}`,
      }),
    }),
    createSchedulePhase: build.mutation<ISchedulePhase, ICreateSchedulePhaseBody>({
      query: (data) => ({
        url: Endpoints.SCHEDULE_PHASES,
        body: data,
        method: 'POST',
      }),
      invalidatesTags: (result, _, args) =>
        result ? [{ type: 'Projects', id: args.projectId }, 'Projects'] : [],
    }),
    updateSchedulePhase: build.mutation<ISchedulePhase, IUpdateSchedulePhaseBody>({
      query: ({ projectId, withoutRefetching, ...data }) => ({
        url: Endpoints.SCHEDULE_PHASES,
        body: data,
        method: 'PATCH',
      }),
      invalidatesTags: (result, _, args) =>
        result && !args?.withoutRefetching ? [{ type: 'Projects', id: args.projectId }, 'Projects'] : [],
    }),
    updateSchedulePhaseBulk: build.mutation<
      TUpdateSchedulePhaseBulkResponse,
      TUpdateSchedulePhaseBulkBody
    >({
      query: (data) => ({
        url: `${Endpoints.SCHEDULE_PHASES}bulk`,
        body: data,
        method: 'PATCH',
      }),
    }),
    deleteSchedulePhase: build.mutation<undefined, IDeleteSchedulePhaseBody>({
      query: ({ id }) => ({
        url: `${Endpoints.SCHEDULE_PHASES}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, err, args) => (!err ? [{ type: 'Projects', id: args.projectId }, 'Projects'] : []),
    }),
  }),
});

export const {
  useGetSchedulePhasesQuery,
  useLazyGetSchedulePhasesQuery,
  useCreateSchedulePhaseMutation,
  useUpdateSchedulePhaseMutation,
  useUpdateSchedulePhaseBulkMutation,
  useDeleteSchedulePhaseMutation,
} = schedulePhasesApi;
